const paymentSystems = [
  "Google Pay",
  "Apple Pay",
  "Samsung Pay",
  "Mada",
  "STC Pay",
  "Fawry Pay",
  "Meeza",
  "Vodafone",
  "Valu",
];

export const MobilePaymentSystems = () => {
  return (
    <div className="text-primary flow-root overflow-x-auto">
      <div className="border inline-block rounded-md align-middle min-w-[260px] w-full max-w-[405px]">
        <table className="divide-y w-full divide-gray-300">
          <thead>
            <tr className="text-sm text-left font-bold divide-x divide-gray-200">
              <th
                scope="col"
                className="whitespace-nowrap rounded-t-md h-9 px-4 leading-4 bg-secondary-darkest text-white"
              >
                Name
              </th>
            </tr>
          </thead>
          <tbody className="divide-y text-xs font-semibold divide-gray-200 bg-white">
            {paymentSystems.map((system, index) => (
              <tr key={`payment-system-${index}`}>
                <td className="h-11 px-4 leading-4">{system}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
